export class User {
  userId: string;
  b2cId: string;
  salesForceMasterContactId: string;
  name: string;
  givenName: string;
  lastName: string;
  email: string;

  constructor(
    userId?: string,
    b2cId?: string,
    salesForceMasterContactId?: string,
    name?: string,
    givenName?: string,
    lastName?: string,
    email?: string
  ) {
    this.userId = userId;
    this.b2cId = b2cId;
    this.salesForceMasterContactId = salesForceMasterContactId;
    this.name = name;
    this.givenName = givenName;
    this.lastName = lastName;
    this.email = email;
  }
}
